import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { httpRequestsOnSuccessActions, loadActions } from 'store';
import {FullTable } from 'components';
import { SEND_TO_BILLING, SHORT_OVERPAY_ACTION_TYPE, shortOverpayBody, shortOverpayHead } from './constants';
import { authService } from '../../store/loads/loads.service';
import { usePrimaryModal } from 'utils';

export const ShortOverpay = ({}) => {
  const MINI_LOAD = 'MINI_LOAD';
  const { shortOverpaysList } = useSelector((state) => ({
    shortOverpaysList: state.loads.shortOverpaysList,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const { openPrimary } = usePrimaryModal();

  const renderParams = () => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    return filteredInfo;
  };

  useEffect(() => {
    handleGet('loading');
    const interval = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(interval);
  }, [info]);

  const handleGet = (loading) => {
    const loader = loading === 'loading' ? 'loading' : 'noLoad';
    const filteredInfo = renderParams();
    dispatch(loadActions.getShortOverpay(filteredInfo, loader));
  };

  const handleSubmit = async (item, name) => {
    dispatch(httpRequestsOnSuccessActions.appendSuccess(MINI_LOAD, item.id));
      try {
        await authService.applyPayTo(item.id, {applyTo: name});
        dispatch(httpRequestsOnSuccessActions.removeSuccess(MINI_LOAD));
        dispatch(httpRequestsOnSuccessActions.appendSuccess(SEND_TO_BILLING));
        handleGet('noLoad');
      } catch (e) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess(MINI_LOAD));
      }
  };

  return (
    <div>
        <FullTable
          head={shortOverpayHead}
          body={shortOverpayBody(openPrimary)}
          loadingType={SHORT_OVERPAY_ACTION_TYPE}
          list={shortOverpaysList?.loads}
          listCount={shortOverpaysList?.count}
          noText={'Short ot Overpays'}
          handleClickButton={handleSubmit}
        />
    </div>
  );
};